import { Observable } from "rxjs";
import { TeleconsultaActivateResponseEntity } from "../../../data/repositories/consult/entities/teleconsulta.activate-response.entity";
import { UseCase } from "../../base/use-case";
import { ConsultRepository } from '../../repositories/consult.repository';

export class ActivateTeleconsultaUseCase implements UseCase<{ id: string, descripcion: string }, TeleconsultaActivateResponseEntity> {
    constructor(private ConsultRepository: ConsultRepository) { }
    execute(
        params: {id: string, descripcion: string},
    ): Observable<TeleconsultaActivateResponseEntity> {
        return this.ConsultRepository.activateTeleconsulta(params);
    }
}
